import { Skeleton } from "@/components/ui/skeleton";

/**
 * Cartões de pedido em cinza nas colunas do Delivery enquanto a 1ª leitura dos
 * pedidos chega (dono, 25/10/2026) — no lugar do círculo girando na tela toda e
 * de "Nenhum pedido…" antes da hora. Mesmo molde do cartão de verdade: código
 * e tempo, cliente, local, valor e o botão da base. A releitura de 5 s não
 * volta a eles.
 */
export default function CartoesPedidoCarregando({ quantos = 3 }) {
  return (
    <div className="space-y-2" data-e2e="delivery-carregando" aria-busy="true" aria-label="Carregando">
      {Array.from({ length: quantos }, (_, i) => (
        <div key={i} className="rounded-xl border border-l-4 bg-card p-3 flex flex-col gap-2.5">
          <div className="flex items-center justify-between gap-2">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-5 w-14 rounded-full" />
          </div>
          <Skeleton className="h-3.5 w-40 max-w-full" />
          <Skeleton className="h-3 w-3/4" />
          <div className="flex items-center justify-between gap-2">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-3 w-16" />
          </div>
          <Skeleton className="h-9 w-full rounded-lg" />
        </div>
      ))}
    </div>
  );
}
